import { Component, ViewEncapsulation, OnInit, OnDestroy, ElementRef, ViewChild, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { AppHelperService } from 'modules/app/services/app-helper.service';
import { LoaderService } from 'modules/app/services/loader.service';
import { ContentHelper } from 'libs-content-helper';
import { ProductViewHelperService } from 'modules/foc/services/product-view-helper.service';
import { ProductTocService } from 'modules/foc/services/product-toc.service';
import { TestSubTypeConstants, testTypeTagsEnum } from 'modules/foc/constants/test.constants';
import { NetwordDetectionService } from 'modules/app/services/network-detection.service';
import { LODBHelperService } from 'modules/foc/services/lo-db-helper.service';
import { environment } from 'environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'activity-launch',
  templateUrl: './activity-launch.template.html',
  standalone: false,
  styleUrls: ['./activity-launch.style.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ActivityLaunch implements OnInit, OnDestroy {
    contentHelper = ContentHelper;

    paramsSubscription: Subscription;
    activityCloseCalledSubscription: Subscription;
    saveAlertActionSubscription: Subscription;
    
    @Input() inputConfig: {
        productData: any,
        productCode?: string,
        itemId?: string,
        userRole: string,
        metaData: any,
        loProfile?: any,
    };

    itemid: string;
    toc: any;
    selectedItemData: any;
    selectedItem: any = {};
    bookPath: string;
    productMeta: any;
    productCode: string;
    bundleDetails:any;
    testTagErrObj: any = {};
    skillSubType = ["cup-pskill", "cup-pskill-group", "cup-collab-task"];
    showLtiResultScreen: boolean = false;

    networkStatusSubscription: Subscription;
    isOnline: boolean;
    /* segment primary or secondary*/
    segment: string = '';
    @ViewChild('showSaveAlertModalBtn') showSaveAlertModalBtn: ElementRef;

    isFirstLaunchedActivity: boolean = true;
    recordingSaveAlertNeeded: boolean = false; 
    ltiGiId: string;
    
    constructor(
        private productViewHelperService: ProductViewHelperService,
        private appHelperService: AppHelperService,
        private loaderService: LoaderService,
        private productTocService: ProductTocService,
        private networkService: NetwordDetectionService,
        private lODBHelperService: LODBHelperService,
        private route: ActivatedRoute
    ) { }

    async ngOnInit() {
        // console.log("in ngOnInit productData: ", this.inputConfig.productData);
        this.loaderService.hideLoader();
        // var productTOCData = this.route.parent.snapshot.data.activityViewResolverData.productData;
        var productTOCData = this.inputConfig.productData;
        this.toc = productTOCData.toc;
        this.productMeta = productTOCData.meta.meta;
        this.bookPath = productTOCData.meta.meta.paths['public-assets'];
        this.bundleDetails = productTOCData.bundleDetails;

        this.productCode = this.inputConfig.productCode;
        this.setSelectedItem(this.inputConfig.itemId);

        //Get segment style - to display corresponding result screen accordingly
        const classProduct = productTOCData.bundleDetails.products.find((product) => product['dls-product'].code === this.productCode);
        this.segment = (classProduct && classProduct.segment) ? classProduct.segment.segment : '';
        //Recording alert activity closed case
        this.activityCloseCalledSubscription = this.productViewHelperService.activityCloseCalled.subscribe((res)=> {
            if(!this.productViewHelperService.isTeacher && this.selectedItemData && this.selectedItemData["sub-type"] == "cup-pskill" && this.selectedItemData["cup-pskill"]["cup-options"] 
            && this.selectedItemData["cup-pskill"]["cup-options"].submissionType && this.selectedItemData["cup-pskill"]["cup-options"].submissionType.id == 'speak' ) {
                if(this.recordingSaveAlertNeeded) {
                    this.showSaveAlertModalBtn.nativeElement.click();
                    if(this.saveAlertActionSubscription) {
                        this.saveAlertActionSubscription.unsubscribe();
                    }
                    this.saveAlertActionSubscription = this.productViewHelperService.saveAlertAction.subscribe((result) => {
                        this.recordingSaveAlertNeeded = false; //To avoid showing alert again
                        if(result == true) {//Exit Button Case
                            this.productViewHelperService.saveAlertActionOnActivityClose.next(null);
                        }
                    });
                } else {
                    this.productViewHelperService.saveAlertActionOnActivityClose.next(null);
                }
            } else {
                this.productViewHelperService.saveAlertActionOnActivityClose.next(null);
            }
        })
        this.ltiGiId = this.route.snapshot.queryParams['ltiGiId'];
        
        // check for online/offline
        this.isOnline = await this.networkService.isOnline();
        this.networkStatusSubscription = this.networkService.monitorStatus().subscribe((isOnline) => {
            this.isOnline = isOnline;
        })
    }

    private setSelectedItem (itemid) {
        this.itemid = decodeURIComponent(itemid);
        let decodedParamsArray = this.itemid.split('/');
        
        /* NEMO-4752 - Code is not generic for n-folder levels */
        if(decodedParamsArray.length === 1) {
            this.selectedItem = {
                ...(decodedParamsArray[0] && {activityId : decodedParamsArray[0]})
            }
        }
        else if(decodedParamsArray.length === 2) {
            this.selectedItem = {
                ...(decodedParamsArray[0] && {lessonId : decodedParamsArray[0]}),
                ...(decodedParamsArray[0] && {activityId : decodedParamsArray[0] + '/' + decodedParamsArray[1]})
            }
        }
        else {
            this.selectedItem = {
                ...(decodedParamsArray[0] && {unitId : decodedParamsArray[0]}),
                ...(decodedParamsArray[1] && {lessonId : decodedParamsArray[0] + '/' + decodedParamsArray[1]}),
                ...(decodedParamsArray[2] && {activityId : decodedParamsArray[0] + '/' + decodedParamsArray[1] + '/' + decodedParamsArray[2]}),
            };
        }

        this.selectedItemData = this.getSelectedItemData(this.toc, this.itemid);

        // Get mapped tags from backend and get test type tags.
        const bundleProduct = this.bundleDetails.products.find((product) => product['dls-product'] && this.productCode && product['dls-product'].code === this.productCode);
        this.testTagErrObj = {};
        if (this.productViewHelperService.isTestTypeComponent(bundleProduct)) {
            this.addTestTypeTagToSelectedItem();
        }
        
        if (!this.isFirstLaunchedActivity) {
            this.showLtiResultScreen = false;
        }

        this.productViewHelperService.selectedItemId.next({itemid: this.itemid, selectedItem: this.selectedItem, selectedItemData: this.selectedItemData, showLtiResultScreen: this.showLtiResultScreen});

        this.setSelectedItemData();
    }

    /* Function to get selected item data  */
    private getSelectedItemData(toc, itemId) {
        let activityItems = [];
        let selectedItemData;
        toc.tocArray.result.some((unit, unitIndex) => {
            activityItems = this.productTocService.getLeafNodeItems(unit);
            selectedItemData = activityItems.find((activity) => {
                let itemCode = decodeURIComponent(activity['item-code']);
                return (itemId === itemCode);
            })
            return selectedItemData;
        });
        return selectedItemData;
    }

    private setSelectedItemData () {
        if (this.isFirstLaunchedActivity) {
            this.isFirstLaunchedActivity = false;
            setTimeout(() => {
                this.activateSubTypeExt();    
            }, 0);    
        }        
        if (ContentHelper.isDownloadableContent(this.selectedItemData)) {
            var subType = this.selectedItemData["sub-type"];
            var downloadUrl = this.appHelperService.isAbsoluteUrl(this.selectedItemData[subType].url) ? this.selectedItemData[subType].url : (this.bookPath + '/' + this.selectedItemData[subType].url);
            this.selectedItemData.downloadUrl = downloadUrl;
            this.selectedItemData.filename = this.selectedItemData[subType].filename;
        } else if (this.skillSubType.indexOf(this.selectedItemData["sub-type"]) > -1){
            //productive-skill component auto handles
            //add itemid to 'pskill' input to be used in productive-skill component
            this.selectedItemData[this.selectedItemData["sub-type"]]['cup-options'].itemid = this.itemid;
            //this.selectedItemData[]
        }
    }

    // Function to update error message for test type tags.
    private updateErrorMsgForTestTypeTags(testTypeTags) {
        if (testTypeTags.length === 0) {
            this.testTagErrObj.errorMsg = 'LEARNER.ACTIVITYLAUNCH.NO_TEST_TYPE_ERROR';
        }
        else if (testTypeTags.length > 1) {
            this.testTagErrObj.errorMsg = 'LEARNER.ACTIVITYLAUNCH.MULTIPLE_TEST_TAG_ERROR';
        }
    }

    // Function to add test type tag to selected item.
    private addTestTypeTagToSelectedItem() {
        let testTypeTags = [];
        if (this.selectedItemData && this.selectedItemData.model && this.selectedItemData.model['test-type']) {
            const testSubType = TestSubTypeConstants[this.selectedItemData.model['test-type']];
            const testTypeTag = testSubType && testTypeTagsEnum[testSubType];
            testTypeTag && testTypeTags.push(testTypeTag);
        } else {
            testTypeTags = this.selectedItemData && this.selectedItemData.mappedTags && this.productViewHelperService.getTestTypeTags(this.selectedItemData.mappedTags);
        }
        if (testTypeTags) {
            // in case of pskill, do not display error msg regarding tags.
            if (!ContentHelper.isSubmittableContent(this.selectedItemData)) {
                this.updateErrorMsgForTestTypeTags(testTypeTags);
            }

            if (!this.testTagErrObj.errorMsg) {
                this.selectedItemData.testTypeTag = testTypeTags[0];
            }
        }
    }

    private async activateSubTypeExt() {
        var contentPath = this.bookPath + '/' + this.selectedItemData[this.selectedItemData["sub-type"]]['url'];
        var contentType = this.selectedItemData["sub-type"];

        var initParams: any = {
            learningObject: {
                path: contentPath,
                contentType: contentType,
                code: this.itemid,
                name: this.itemid,
                isOffline: environment.isDesktopApp && !this.isOnline,
                meta: { contributesToCompletion: this.selectedItemData['contributes-to-completion'] },
                isPersistentState: true,
                loProfile: this.inputConfig.loProfile
            }
        };
        // For pskill type or ext-cup-xapiscoreable type activities send ltiGiId to xapi runner in ltiGradebookItemId
        if((this.skillSubType.indexOf(contentType) > -1 || contentType === "ext-cup-xapiscoreable" || contentType === "generic-lti")  && this.ltiGiId) {
            initParams.learningObject.ltiPlatform = {
                "ltiGradebookItemId": this.ltiGiId
            }
        }
        var containerType = 'avallain-opener';
        if(this.selectedItemData[contentType]['container'] === 'Channel') {
            containerType = 'generic-content';
        }

        // ~~TODO~~ : Logic to fetch states for LO and use the latest state.
        /**
         * get data from server(online) and LS(DB).
         * if found in none, use normal flow.
         * if found in any one and not other, use the found and set in other.
         * if found in both, use with greater timestamp.
         * if using from server, update that in DB as well.
         */

        let stateResponse;

        if (this.inputConfig.metaData.userRole == 'student' && this.inputConfig.metaData.isPEDownloaded) {
            let LSstateResponse = await this.lODBHelperService.fetchFromStatesVM(this.inputConfig.metaData.spaceId, this.inputConfig.metaData.classId, this.inputConfig.metaData.productCode, this.itemid);
            let serverStateResponse;

            if (this.isOnline) {
                serverStateResponse = await this.productViewHelperService.getXAPIAnalyticsObject().getState(this.itemid);

                console.log(' ~~ serverStateResponse', serverStateResponse);
                console.log(' ~~ LSstateResponse', LSstateResponse);

                if (serverStateResponse || LSstateResponse) {
                    if (serverStateResponse && !LSstateResponse) {
                        stateResponse = serverStateResponse;
                        await this.lODBHelperService.storeInStatesVM(this.inputConfig.metaData.extUserId, this.inputConfig.metaData.spaceId, this.inputConfig.metaData.classId, this.inputConfig.metaData.productCode, this.itemid, serverStateResponse);
                    } else if (!serverStateResponse && LSstateResponse) {
                        stateResponse = LSstateResponse;
                        this.productViewHelperService.getXAPIAnalyticsObject().postStateNoBatch(LSstateResponse);
                    } else {
                        if (LSstateResponse.timestamp > serverStateResponse.timestamp) {
                            stateResponse = LSstateResponse;
                            this.productViewHelperService.getXAPIAnalyticsObject().postStateNoBatch(LSstateResponse);
                        } else if (LSstateResponse.timestamp < serverStateResponse.timestamp) {
                            stateResponse = serverStateResponse;
                            await this.lODBHelperService.storeInStatesVM(this.inputConfig.metaData.extUserId, this.inputConfig.metaData.spaceId, this.inputConfig.metaData.classId, this.inputConfig.metaData.productCode, this.itemid, serverStateResponse);
                        } else {
                            // case when both are equal, use from server but dont add to DB or sync.
                            stateResponse = serverStateResponse;
                        }
                    }
                }
            } else {
                if (LSstateResponse) {
                    stateResponse = LSstateResponse;
                }
            }
        }

        
        // __analytics node won't exist for teacher hence we won't call getState for teacher
        if (((this.selectedItemData.__analytics && this.selectedItemData.__analytics.status === "in_complete") || stateResponse || initParams.learningObject.isPersistentState) && (contentType === "ext-cup-xapi" || contentType === "ext-cup-xapiscoreable") && (this.inputConfig.userRole == 'student')) {

            let response;

            if (stateResponse) {
                response = stateResponse;
                stateResponse = undefined;
            } else {
                response = await this.productViewHelperService.getXAPIAnalyticsObject().getState(this.itemid);
            }

            initParams.learningObject.state = response;
            initParams.container = {
                type: containerType,
                config: {
                    disableLOButtons: true,
                    enableLOProfile: true
                }
            };

            if (this.inputConfig.userRole == 'student') {
                // set the status for result screen and lastResult value for score.
                // if analytics are available, ie book is non downloaded or webapp, get data from analytics object.
                if (this.selectedItemData.__analytics) {
                    // For learner, pass the value of status from analytics node
                    initParams.learningObject.status = this.selectedItemData.__analytics.status;
                    initParams.learningObject.lastResult = this.selectedItemData.__analytics.lastResult;
                }

                // calculate the score and set in Object.
                let score;
                if (initParams && initParams.learningObject && initParams.learningObject.isPersistentState && initParams.learningObject.status == 'completed' &&
                    initParams.learningObject.state && initParams.learningObject.state.containerMeta && initParams.learningObject.state.containerMeta.isOnResultsScreen) {

                    if (initParams.learningObject && initParams.learningObject.lastResult && initParams.learningObject.lastResult.scaledScore) {
                        initParams.learningObject.lastResult.scaled = initParams.learningObject.lastResult.scaledScore
                    }

                    score = {
                        "scaled": initParams.learningObject.lastResult.scaled,
                        "raw": initParams.learningObject.lastResult.raw,
                        "min": initParams.learningObject.lastResult.min,
                        "max": initParams.learningObject.lastResult.max
                    }
                }
                this.productViewHelperService.setScoreObject(score);

            }

            //param to show c1 result screen for generic scorable
            if (ContentHelper.containerResultScreen(this.selectedItemData)) {
                initParams.container.config.loExternalResultScreen = true;
            }  

            if (this.selectedItemData[contentType]["cup-options"]) {
                initParams.container.config.paths = {
                    engine: this.selectedItemData[contentType]["cup-options"].engine,
                    dp: this.selectedItemData[contentType]["cup-options"].dp
                }
            }
            this.productViewHelperService.setLOInitParams(initParams);
            this.productViewHelperService.getXAPIRunnerObject().paintActivity(this.itemid, "content-course-ext", initParams);

        } else {
            if (contentType === "ext-cup-html") {
                this.productViewHelperService.getXAPIRunnerObject().paintActivity(this.itemid , "content-course-ext", initParams);
            } else if (this.contentHelper.isDownloadableContent(this.selectedItemData)) {
                initParams.container = {
                    type: 'nopack-content',
                    config: {
                        trackLaunch: true,
                        trackClose: true,
                        trackTime: false,
                        trackComplete: true
                    }
                }

                this.productViewHelperService.getXAPIRunnerObject().paintActivity(this.itemid , "content-course-ext", initParams);
            } else if (contentType === "ext-cup-xapi" || contentType === "ext-cup-xapiscoreable") {
                initParams.learningObject.status = "completed"; // By default set status as "completed" (for teachers)
                if (this.selectedItemData.__analytics) {
                    // For learner, pass the value of status from analytics node
                    initParams.learningObject.status = this.selectedItemData.__analytics.status;
                }
                initParams.container = {
                    type: containerType, 
                    config: {
                        disableLOButtons: true,
                        enableLOProfile: true
                    }
                }
                //param to show c1 result screen for generic scorable
                if (ContentHelper.containerResultScreen(this.selectedItemData)) {
                    initParams.container.config.loExternalResultScreen = true;
                }             

                if (this.selectedItemData[contentType]["cup-options"]) {
                    initParams.container.config.paths = {  
                        engine: this.selectedItemData[contentType]["cup-options"].engine,
                        dp: this.selectedItemData[contentType]["cup-options"].dp
                    }
                }
                this.productViewHelperService.getXAPIRunnerObject().paintActivity(this.itemid , "content-course-ext", initParams);
            } else if (["cup-pskill", "cup-pskill-group", "cup-collab-task"].indexOf(contentType) != -1 ) {
                initParams.container = {
                    type: 'nopack-content',
                    config: {
                        trackLaunch: contentType == "cup-collab-task"? true: false,
                        trackClose: true,
                        trackTime: true,
                        trackComplete: false
                    }
                }
                this.productViewHelperService.getXAPIRunnerObject().paintActivity(this.itemid , "content-course-ext", initParams);
            }            
        }
        this.productViewHelperService.setLOInitParams(initParams);
    }

    ngOnDestroy() {
        if(this.paramsSubscription){
            this.paramsSubscription.unsubscribe();
        }
        if(this.activityCloseCalledSubscription) {
            this.activityCloseCalledSubscription.unsubscribe();
        }
        if(this.saveAlertActionSubscription) {
            this.saveAlertActionSubscription.unsubscribe();
        }
        this.networkStatusSubscription.unsubscribe();
        
    }
    
}
